/** Tenant-side WhatsApp notification preferences (Customer Portal). */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";

const LABELS = { enabled: "WhatsApp notifications enabled", orders: "Order notifications", quotes: "Quote notifications", invoices: "Invoice & payment notifications", service: "Service notifications", warranty: "Warranty notifications" };

export default function WhatsAppPrefsCard({ canEdit = true, tenantId }) {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/whatsapp/tenant-prefs", { params: tenantId ? { tenant_id: tenantId } : {} }).then(({ data }) => setP(data.prefs)).catch(() => setP({})); }, [tenantId]);
  const toggle = async (k) => {
    if (!canEdit) return;
    const next = { ...p, [k]: !p[k] };
    setP(next); setBusy(true);
    try { await api.put("/whatsapp/tenant-prefs", { [k]: next[k] }, { params: tenantId ? { tenant_id: tenantId } : {} }); toast.success("Preference saved"); }
    catch (e) { setP(p); toast.error(e.response?.data?.detail || "Not allowed"); } finally { setBusy(false); }
  };
  if (!p) return null;
  return (
    <div className="os-card p-4 space-y-2" data-testid="wa-prefs-card">
      <div className="flex items-center gap-2 text-[13px] font-semibold"><MessageCircle className="h-4 w-4 text-emerald-600" /> WhatsApp notifications</div>
      <p className="text-[12px] text-[color:var(--st-text-muted)]">Approved-template messages only (order, quote, invoice, service, warranty). Individual contacts can also opt out.</p>
      <div className="divide-y divide-[color:var(--st-border)]">
        {Object.keys(LABELS).map((k) => <label key={k} className={"flex items-center justify-between py-2 text-[13px] " + (k !== "enabled" && !p.enabled ? "opacity-50" : "")}><span>{LABELS[k]}</span><input type="checkbox" checked={p[k] !== false} disabled={busy || !canEdit || (k !== "enabled" && !p.enabled)} onChange={() => toggle(k)} className="h-4 w-4" data-testid={`wa-pref-${k}`} /></label>)}
      </div>
    </div>
  );
}
